import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/loginRegister/close_icon.png'


const _hoisted_1 = { class: "pop_container" }
const _hoisted_2 = { class: "register_container" }
const _hoisted_3 = { class: "form_container" }
const _hoisted_4 = { class: "main_title" }
const _hoisted_5 = {
  key: 0,
  class: "content_text"
}
const _hoisted_6 = {
  key: 1,
  class: "content_text"
}
const _hoisted_7 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_8 = {
  key: 2,
  class: "errorNotice"
}
const _hoisted_9 = {
  key: 4,
  class: "errorNotice"
}
const _hoisted_10 = {
  key: 5,
  class: "errorNotice"
}
const _hoisted_11 = {
  key: 6,
  class: "human_verify"
}
const _hoisted_12 = { class: "btn_container" }

import { ref, computed, onBeforeMount } from 'vue';
import InputField from './components/inputField.vue';
import MainButton from '@/components/common/mainButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { v4 as uuidv4 } from 'uuid';
import { login, register } from '@/api/user';
import { useUserStore } from '@/stores/user';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { initSSE } from '@/utils/sse';
import { useGameStore } from '@/stores/games';


export default /*@__PURE__*/_defineComponent({
  __name: 'registerLoginPopup',
  setup(__props, { expose: __expose }) {

const userStore = useUserStore()
const gameStore = useGameStore()
const phoneNumber = ref('')
const password = ref('')
const confirmPassword = ref('')
const agentKey = ref('')
const phoneValidationNotice = ref(false)
const passwordValidationNotice = ref(false)
const confirmPasswordValidationNotice = ref(false)
const show = ref(false)
const signType = ref(0)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const isPWA = ref(false);
const open = (type: number) => {
    show.value = true
    signType.value = type
}

const close = () => {
    show.value = false
}

const changeSignType = (value: number) => {
    signType.value = value
}

const phoneNumberChange = (value: string) => {
    phoneNumber.value = value
    checkPhoneValidation(value)
}

const passwordChange = (value: string) => {
    password.value = value
    checkPasswordValidation(value)
}

const confirmPasswordChange = (value: string) => {
    confirmPassword.value = value
    checkConfirmPasswordValidation(value)
}

const isRegisterBtnActive = computed(() => {
  if (signType.value === 0) {
    return (
      phoneNumber.value.length > 0 &&
      password.value.length > 0 &&
      confirmPassword.value.length > 0 &&
      !phoneValidationNotice.value &&
      !passwordValidationNotice.value &&
      !confirmPasswordValidationNotice.value
    );
  }
  return false;
});
const isLoginBtnActive = computed(() => {
  if (signType.value === 1) {
    return (
      phoneNumber.value.length > 0 &&
      password.value.length > 0 &&
      !phoneValidationNotice.value &&
      !passwordValidationNotice.value
    );
  }
  return false;
});
const checkPhoneValidation = (value: any) => {
    if (value.length == 11 && value[2] == '9' || value.length == 0) {

        phoneValidationNotice.value = false
    } else {
        phoneValidationNotice.value = true
    }
}
const checkPasswordValidation = (value: any) => {
    if (value.length >= 8 && value.length <= 20 || value.length == 0) {
        passwordValidationNotice.value = false
    } else {
        passwordValidationNotice.value = true
    }
}
const checkConfirmPasswordValidation = (value: any) => {
    if (value.length >= 8 && value.length <= 20 || value.length == 0) {
        confirmPasswordValidationNotice.value = false
    } else {
        confirmPasswordValidationNotice.value = true
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const signIn = (isReg:boolean) => {
    if(!isReg) {
        loadingRef.value.open();
    }
    const params = {
        username: phoneNumber.value,
        code: "2",
        grantType: "password",
        password: password.value,
        rememberMe: false,
        tenantId: process.env.VUE_APP_TENANT_ID,
        clientId: process.env.VUE_APP_CLIENT_ID,
        uuid: ""
    }
    login(params).then(res => {
        loadingRef.value.close()
        setTimeout(() => {
            if(!isReg) {
                showSuccess(res.msg);
            }
            show.value = false;
        }, 500)
        localStorage.setItem('token', res.data.access_token);
        initSSE(process.env.VUE_APP_BASE_API + '/app/resource/sse');
        gameStore.getGameGroupListData()
        if(isPWA.value) {
            userStore.getInfo();
            userStore.getPWARewardAPI();
        } else {
            userStore.getInfo();
        }
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const signUp = () => {
    loadingRef.value.open()
    const params = new URLSearchParams(window.location.hash.split('?')[1] || '')
    agentKey.value = params.get('ref') || ''
    const data = {
        username: phoneNumber.value,
        password: password.value,
        userType: "app_user",
        registerType: "mobile",
        agentKey: agentKey.value,
        isApp: 1,
        isPwa: 0,
        isApk: 0,
        grantType: "password",
        tenantId: process.env.VUE_APP_TENANT_ID,
        clientId: process.env.VUE_APP_CLIENT_ID
    }
    register(data).then(res => {
        loadingRef.value.close()
         setTimeout(() => {
            showSuccess(res.msg);
            signIn(true)
            // signType.value = 1;
        }, 500)
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}

onBeforeMount(()=>{
    isPWA.value = window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator.standalone === true) ||
        document.referrer.includes('android-app://');
})

__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((show).value = $event)),
      position: "bottom",
      style: {
        minWidth: '100%',
        minHeight: '100vh',
        zIndex: '10002'
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", { class: "close_icon" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: close
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(signType.value == 0 ? _ctx.$t('common.register') : _ctx.$t('common.login')), 1),
              (signType.value == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t('loginRegister.alreadyAcc')) + " ", 1),
                    _createElementVNode("span", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSignType(1)))
                    }, _toDisplayString(_ctx.$t('loginRegister.loginNow')), 1)
                  ]))
                : _createCommentVNode("", true),
              (signType.value == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$t('loginRegister.dontHaveAcc')) + " ", 1),
                    _createElementVNode("span", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeSignType(0)))
                    }, _toDisplayString(_ctx.$t('loginRegister.registerNow')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(InputField, {
                modelValue: phoneNumber.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phoneNumber).value = $event)),
                isShowError: phoneValidationNotice.value,
                onValueChanged: phoneNumberChange,
                labelText: _ctx.$t('profile.phoneNum'),
                isshowFlag: true,
                fieldType: "number"
              }, null, 8, ["modelValue", "isShowError", "labelText"]),
              _createElementVNode("div", null, [
                (phoneValidationNotice.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('loginRegister.phoneFormat')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(InputField, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((password).value = $event)),
                isShowError: passwordValidationNotice.value,
                onValueChanged: passwordChange,
                isPassword: true,
                labelText: _ctx.$t('loginRegister.enterPassword'),
                fieldType: "password"
              }, null, 8, ["modelValue", "isShowError", "labelText"]),
              (passwordValidationNotice.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('loginRegister.passwordForamt')), 1))
                : _createCommentVNode("", true),
              (signType.value == 0)
                ? (_openBlock(), _createBlock(InputField, {
                    key: 3,
                    modelValue: confirmPassword.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmPassword).value = $event)),
                    isShowError: confirmPasswordValidationNotice.value || (password.value !== '' && confirmPassword.value !== '' && password.value !== confirmPassword.value),
                    onValueChanged: confirmPasswordChange,
                    isPassword: true,
                    labelText: _ctx.$t('loginRegister.confirmPassword'),
                    fieldType: "password"
                  }, null, 8, ["modelValue", "isShowError", "labelText"]))
                : _createCommentVNode("", true),
              (confirmPasswordValidationNotice.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('loginRegister.passwordForamt')), 1))
                : (confirmPassword.value && password.value && confirmPassword.value !== password.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('loginRegister.differentPassword')), 1))
                  : _createCommentVNode("", true),
              (signType.value == 0 && false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[7] || (_cache[7] = [
                    _createElementVNode("iframe", {
                      src: "https://challenges.cloudflare.com/cdn-cgi/challenge-platform/h/g/turnstile/if/ov2/av0/rcv/374p4/0x4AAAAAAA_CgXp5DcwwFYjj/light/fbE/auto_timeout/normal/auto/",
                      allow: "cross-origin-isolated; fullscreen; autoplay",
                      sandbox: "allow-same-origin allow-scripts allow-popups",
                      id: "cf-chl-widget-374p4",
                      tabindex: "0",
                      title: "Widget containing a Cloudflare security challenge",
                      style: {"border":"none","overflow":"hidden","width":"300px","height":"65px"}
                    }, null, -1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                (signType.value == 0)
                  ? (_openBlock(), _createBlock(MainButton, {
                      key: 0,
                      title: _ctx.$t('common.register'),
                      activeStatus: isRegisterBtnActive.value,
                      onClick: signUp
                    }, null, 8, ["title", "activeStatus"]))
                  : _createCommentVNode("", true),
                (signType.value == 1)
                  ? (_openBlock(), _createBlock(MainButton, {
                      key: 1,
                      title: _ctx.$t('common.login'),
                      activeStatus: isLoginBtnActive.value,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (signIn(false)))
                    }, null, 8, ["title", "activeStatus"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})